module.exports = __webpack_public_path__ + "img/today.be5030ca.webp";